<section class="ch1"
         [ngClass]="{'with-filter-tag-zone':  (chipsState | async)}">
    <section class="header-zone">
        <ng-content select="[header-zone]"></ng-content>
    </section>
    <section class="visu-zone">
        <ng-content select="[visu-zone]"></ng-content>
    </section>
</section>
